import type { AvatarCategory } from '../../config/avatarLibrary'
import { categoryLabels } from '../../config/avatarLibrary'

interface ImageCategoryFilterProps {
    activeCategory: AvatarCategory
    onCategoryChange: (category: AvatarCategory) => void
}

const categories: AvatarCategory[] = ['all', 'professional', 'casual', 'creative']

export function ImageCategoryFilter({ activeCategory, onCategoryChange }: ImageCategoryFilterProps) {
    return (
        <div className="flex gap-2 overflow-x-auto pb-2 scrollbar-hide">
            {categories.map((category) => (
                <button
                    key={category}
                    onClick={() => onCategoryChange(category)}
                    className={`
                        px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap
                        transition-all duration-200 ease-out
                        focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2
                        ${activeCategory === category
                            ? 'bg-blue-500 text-white shadow-md scale-105'
                            : 'bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700'
                        }
                    `}
                    aria-pressed={activeCategory === category}
                >
                    {categoryLabels[category]}
                </button>
            ))}
        </div>
    )
}
